import { render, staticRenderFns } from "./yuanxiaoduibi.vue?vue&type=template&id=52cd2134&scoped=true"
import script from "./yuanxiaoduibi.vue?vue&type=script&lang=js"
export * from "./yuanxiaoduibi.vue?vue&type=script&lang=js"
import style0 from "./yuanxiaoduibi.vue?vue&type=style&index=0&id=52cd2134&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cd2134",
  null
  
)

export default component.exports